export * from './location.controller';
import location_map from './location_map.html';
import location_prep from './location_prep.html';
import location_tags from './location_tags.html';

export { location_map, location_prep, location_tags }
